import { ChangeDetectionStrategy, Component, inject, input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IncidentFormControls } from 'src/app/types';
import { atLeastOneExtraLinkValidator, duplicateExtraLinksValidator, linkValidator } from '../form-utils';

@Component({
  selector: 'app-review-form-extra-links',
  templateUrl: './review-form-extra-links.component.html',
  styleUrl: './review-form-extra-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormExtraLinksComponent implements OnInit, OnChanges {
  public fb = inject(FormBuilder);
  public isRequired = input<boolean>(false);
  public form = input.required<FormGroup<IncidentFormControls>>();

  public atLeastOneRequired = input<boolean>(false);
  public optionalMessage = input<string>('');

  ngOnInit() {
    this.updateValidators();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['atLeastOneRequired']) {
      this.updateValidators();
    }
  }

  private updateValidators() {
    const extraLinks = this.form().controls.extraLinks;
    const validators = [duplicateExtraLinksValidator];

    if (this.atLeastOneRequired()) {
      validators.push(atLeastOneExtraLinkValidator);
    }

    extraLinks.setValidators(validators);
    extraLinks.updateValueAndValidity({ emitEvent: true });
  }

  public addExtraLink() {
    const extraLinks = this.form().controls.extraLinks;
    extraLinks.push(this.fb.control('', linkValidator));
    extraLinks.markAsDirty();
    extraLinks.updateValueAndValidity();
  }

  public trimExtraLink(index: number) {
    const link = this.form().controls.extraLinks.at(index);
    const trimmed = link.value.trim();
    if (trimmed !== link.value) {
      link.setValue(trimmed);
    }
  }

  public removeExtraLink(index: number) {
    const extraLinks = this.form().controls.extraLinks;
    if (index < 0 || index >= extraLinks.length) return;
    extraLinks.removeAt(index);
    extraLinks.markAsDirty();
    extraLinks.updateValueAndValidity();
  }
}
